export default "/static/dashboard/build/app/img/v2/745058553a340c5ee5668f196efc4518.png";